/* @flow */

import * as React from 'react';
import numeral from 'numeral';
import { TweenMax, Linear } from 'gsap';
import { isNumber } from 'lodash';

type Props = {
  className?: string,
  duration?: number,
  format?: string,
  number: number | string,
  animate?: boolean
};

type State = {
  number: number | string
};

class AnimateNumber extends React.Component<Props, State> {
  props: Props;

  tween: TweenMax; // eslint-disable-line react/sort-comp

  static defaultProps = {
    className: undefined,
    duration: 1,
    format: undefined,
    animate: true
  };

  constructor(props: Props) {
    super(props);

    const { number } = props;

    this.state = {
      number
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (!nextProps.animate) {
      this.setState({ number: nextProps.number });
      return;
    }

    const { number } = this.props;

    if (number !== nextProps.number) {
      this.tween = TweenMax.to(
        {
          value: number
        },
        nextProps.duration,
        {
          value: nextProps.number,
          onUpdate: this.handleUpdate,
          onUpdateParams: ['{self}'],
          onUpdateScope: this,
          ease: Linear.easeNone
        }
      );
    }
  }

  componentWillUnmount() {
    if (this.tween) {
      this.tween.kill();
    }
  }

  handleUpdate(tween) {
    this.setState({
      number: tween.target.value
    });
  }

  render() {
    const { className, format } = this.props;

    const { number } = this.state;

    return (
      <span className={className}>
        {isNumber(number) ? numeral(number).format(format) : number}
      </span>
    );
  }
}

export default AnimateNumber;
